export default __webpack_public_path__ + "static/media/guide_00.ac038a6e.md";